import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
import { specials, BOOKING_URL } from '../../data/services';

export const SpecialsSection = () => {
  return (
    <section 
      data-testid="specials-section"
      className="py-24 lg:py-32 bg-light relative noise-overlay"
    >
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="font-cinzel text-amaranth text-xs tracking-[0.3em] mb-4">
            EXCLUSIVE OFFERS
          </p>
          <h2 className="font-serif text-dark text-4xl lg:text-5xl">
            Current Specials
          </h2>
        </motion.div>

        {/* Specials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {specials.map((special, index) => (
            <motion.div
              key={special.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              data-testid={`special-card-${special.id}`}
              className="group relative bg-chalk p-8 lg:p-10 hover:shadow-soft transition-shadow duration-300"
            >
              {/* Badge */}
              <span className="absolute top-4 right-4 bg-amaranth text-white text-xs px-3 py-1 rounded-full">
                {special.badge}
              </span>

              {/* Icon */}
              <div className="w-12 h-12 bg-thulian/10 flex items-center justify-center mb-6">
                <Sparkles className="text-amaranth" size={24} />
              </div>

              {/* Content */}
              <h3 className="font-serif text-dark text-2xl mb-3">
                {special.title}
              </h3>
              <p className="text-dark-secondary text-sm mb-6 leading-relaxed">
                {special.description}
              </p>

              {/* Price */}
              <p className="font-serif text-amaranth text-xl mb-6">
                {special.price}
              </p>

              {/* CTA */}
              <a
                href={BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`special-cta-${special.id}`}
                className="inline-flex items-center gap-2 text-dark text-sm font-medium group-hover:text-amaranth transition-colors"
              >
                Book Now
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </a>
            </motion.div>
          ))}
        </div>

        {/* View All Link */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="text-center mt-12"
        >
          <Link
            to="/specials"
            data-testid="view-all-specials"
            className="inline-flex items-center gap-2 text-amaranth font-medium hover:gap-3 transition-all"
          >
            View All Specials
            <ArrowRight size={18} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default SpecialsSection;
